import React from 'react';
import { Outlet } from 'react-router-dom';

import { Wrap } from '@components';

const AiAgentPage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default AiAgentPage;
